import { ProductColor } from '@cemex-core/cmx-api/models/product-color/models/product-color/ProductColor';
import {
  LOAD_IVM_PRODUCTS,
  LOAD_IVM_PRODUCTS_COMPLETE,
  LOAD_PLANTS_COMPLETE,
  LOAD_PRODUCT_COLORS,
  LOAD_PRODUCT_COLORS_COMPLETE,
  LOAD_PRODUCTS,
  LOAD_PRODUCTS_COMPLETE,
  ProductCatalogActions,
  RESET_PRODUCT_CATALOG,
  RESET_PRODUCT_COLORS,
  SET_FILTER_PRODUCT_CODE,
  SET_FILTER_PRODUCT_DESC,
  SET_SELECTED_PLANT,
  SET_SELECTED_PLANT_BY_ID,
  SET_SELECTED_PRODUCT_COLOR,
} from '../../actions/product-catalog.actions';
import { ProductColorResponse } from '@cemex-core/cmx-api/models/product-color/product-color-res';
import { Plant, ProductOP } from '@cemex-core/cmx-api';
import { IProduct } from '@cemex-core/cmx-api/models/product/models/product.interface';

export interface ProductCatalogState {
  productColors: ProductColor[];
  selectedProductColor: ProductColor;
  plants: Plant[];
  selectedPlant: Plant;
  products: IProduct[];
  productsIVM: ProductOP[];
  productsLoading: boolean;
  productDescriptionInput: string;
  productCodeInput: string;
  productLoaded: boolean;
  colorsLoaded: boolean;
}

export const initialState: ProductCatalogState = {
  productColors: [],
  selectedProductColor: null,
  plants: [],
  selectedPlant: null,
  products: [],
  productsIVM: [],
  productDescriptionInput: '',
  productCodeInput: '',
  productLoaded: false,
  colorsLoaded: false,
  productsLoading: false,
};

export function productCatalogReducer(state = initialState, action: ProductCatalogActions): ProductCatalogState {
  switch (action.type) {
    case LOAD_PLANTS_COMPLETE: {
      return {
        ...state,
        plants: action.payload.plants,
      };
    }
    case LOAD_PRODUCTS:
    case LOAD_IVM_PRODUCTS: {
      return {
        ...state,
        productsLoading: true,
      };
    }
    case LOAD_PRODUCTS_COMPLETE: {
      return {
        ...state,
        productLoaded: true,
        productsLoading: false,
        products: action.payload.products,
      };
    }
    case LOAD_IVM_PRODUCTS_COMPLETE: {
      return {
        ...state,
        productLoaded: true,
        productsLoading: false,
        products: [],
        productsIVM: action.payload.products,
      };
    }
    case SET_SELECTED_PLANT: {
      return {
        ...state,
        selectedPlant: action.payload,
      };
    }
    case SET_SELECTED_PLANT_BY_ID: {
      if (action.payload === null) {
        return {
          ...state,
          selectedPlant: null,
        };
      }

      return {
        ...state,
        selectedPlant: state.plants.find(plant => {
          return Number(plant.plantId) === Number(action.payload.plantId);
        }),
      };
    }
    case LOAD_PRODUCT_COLORS: {
      return {
        ...state,
        colorsLoaded: false,
      };
    }
    case LOAD_PRODUCT_COLORS_COMPLETE: {
      const payload = action.payload as ProductColorResponse;

      return {
        ...state,
        colorsLoaded: true,
        productColors: payload.productColors,
      };
    }
    case SET_SELECTED_PRODUCT_COLOR: {
      return {
        ...state,
        selectedProductColor: state.productColors.find(productColor => {
          return Number(productColor.productColorId) === Number(action.payload.productColorId);
        }),
      };
    }
    case SET_FILTER_PRODUCT_DESC: {
      return {
        ...state,
        productDescriptionInput: action.payload,
      };
    }
    case SET_FILTER_PRODUCT_CODE: {
      return {
        ...state,
        productCodeInput: action.payload,
      };
    }
    case RESET_PRODUCT_COLORS: {
      return {
        ...state,
        productColors: initialState.productColors,
      };
    }
    case RESET_PRODUCT_CATALOG: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
